export const PANJANG_KODE_REFERRAL = 8
export const ALFABET_KODE_REFERRAL = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789"
export const BATAS_RELASI_PER_PENGUNDANG = 500
export const JUMLAH_RELASI_HALAMAN = 20

export interface PengaturanReferral {
  aktif: boolean
  rewardPengundang: number
  rewardDiundang: number
  minimalPembelian: number
}

export const PENGATURAN_REFERRAL_BAWAAN: PengaturanReferral = {
  aktif: true,
  rewardPengundang: 5_000,
  rewardDiundang: 2_000,
  minimalPembelian: 20_000,
}

export type StatusRelasiReferral = "menunggu" | "selesai" | "ditolak"

export interface RelasiReferral {
  id: string
  namaSamar: string
  status: StatusRelasiReferral
  rewardKoin: number
  dibuatPada: string
  selesaiPada: string | null
}

export interface RingkasanReferral {
  kode: string
  tautan: string | null
  totalDiundang: number
  menunggu: number
  selesai: number
  totalKoin: number
  pengaturan: PengaturanReferral
  kodeDipakai: boolean
  bisaPakaiKode: boolean
}

export const LABEL_STATUS_REFERRAL: Record<StatusRelasiReferral, string> = {
  menunggu: "Menunggu pembelian",
  selesai: "Selesai",
  ditolak: "Tidak memenuhi syarat",
}

export function rapikanKodeReferral(mentah: unknown): string | null {
  if (typeof mentah !== "string") return null
  const kode = mentah.trim().toUpperCase().replace(/[\s-]/g, "")
  if (kode.length !== PANJANG_KODE_REFERRAL) return null
  for (const huruf of kode) if (!ALFABET_KODE_REFERRAL.includes(huruf)) return null
  return kode
}

export function buatKodeDariAcak(acak: ArrayLike<number>): string {
  let hasil = ""
  for (let i = 0; i < PANJANG_KODE_REFERRAL; i++) hasil += ALFABET_KODE_REFERRAL[acak[i] % ALFABET_KODE_REFERRAL.length]
  return hasil
}

export function samarkanNama(nama: string): string {
  const bersih = nama.trim().replace(/\s+/g, " ")
  if (bersih.length === 0) return "Pengguna"
  const kata = bersih.split(" ")[0]
  const awal = Array.from(kata).slice(0, 2).join("")
  return `${awal}${"*".repeat(Math.max(2, Math.min(4, Array.from(kata).length - 2)))}`
}

export function rapikanPengaturanReferral(mentah: unknown): PengaturanReferral {
  const sumber = typeof mentah === "object" && mentah !== null ? (mentah as Record<string, unknown>) : {}
  const angka = (nilai: unknown, bawaan: number, maks: number): number =>
    typeof nilai === "number" && Number.isInteger(nilai) && nilai >= 0 && nilai <= maks ? nilai : bawaan
  return {
    aktif: typeof sumber.aktif === "boolean" ? sumber.aktif : PENGATURAN_REFERRAL_BAWAAN.aktif,
    rewardPengundang: angka(sumber.rewardPengundang, PENGATURAN_REFERRAL_BAWAAN.rewardPengundang, 1_000_000),
    rewardDiundang: angka(sumber.rewardDiundang, PENGATURAN_REFERRAL_BAWAAN.rewardDiundang, 1_000_000),
    minimalPembelian: angka(sumber.minimalPembelian, PENGATURAN_REFERRAL_BAWAAN.minimalPembelian, 100_000_000),
  }
}

export function uangNyataPembelian(pembayaran: { total?: unknown; dompet?: { koin?: unknown } | null; metodePembayaran?: { tipe?: unknown } | null }): number {
  const total = typeof pembayaran.total === "number" ? pembayaran.total : 0
  if (pembayaran.metodePembayaran?.tipe === "gratis" && !pembayaran.dompet) return 0
  const koin = typeof pembayaran.dompet?.koin === "number" ? pembayaran.dompet.koin : 0
  return Math.max(0, total - koin)
}

export function bolehMendapatReward(masukan: { uangNyata: number; pengaturan: PengaturanReferral; ipSama: boolean }): { boleh: true } | { boleh: false; alasan: "nominal" | "ip" | "nonaktif" } {
  if (!masukan.pengaturan.aktif) return { boleh: false, alasan: "nonaktif" }
  if (masukan.ipSama) return { boleh: false, alasan: "ip" }
  if (masukan.uangNyata < masukan.pengaturan.minimalPembelian) return { boleh: false, alasan: "nominal" }
  return { boleh: true }
}

export function tautanUndangan(urlMember: string | null, kode: string): string | null {
  return urlMember ? `${urlMember}/daftar?ref=${kode}` : null
}
